export function RayIcon() {
  return (
    <svg viewBox="0 0 20 20" fill="currentColor">
      <path d="M12,9.414L6.707,14.707L5.293,13.293L10.586,8L8,8L8,6L13,6C13.552,6 14,6.448 14,7L14,12L12,12L12,9.414Z" />
    </svg>
  );
}
